const DEFAULT_ERROR = 'Une erreur imprévue est survenue, veuillez réessayer.';

let app = window.app;

export default function getErrorsFromResponse ({ response={ }, error, redirect })
{
	error = error || DEFAULT_ERROR;

	app.state.form_error = response.error;

	if (redirect !== false && app.redirectIfNeeded(response.pathname))
	{
		return { };
	}

	let update =
	{
		loading: false,

		info: undefined,
		error: !response.warning ? response.error || error : undefined,
		warning: response.warning,

		status_messages: response.fields || { }
	};

	return update;
}